import {
	Button,
	SendReminderModal,
	TailwindModal,
	Typography
} from 'components'
import { GenericModalProps, Images, TypographyTypes } from 'interfaces'
import React, { useState } from 'react'

export const MyPeopleReminderModal: React.FC<GenericModalProps<number[]>> = ({
	open,
	setOpen,
	setMyPeopleDataSelected
}) => {
	const [loginReminder, setLoginReminder] = useState(false)

	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			title="Send Login reminders"
			titleClassName="font-bold text-[24px] leading-[28px]"
			className="w-[513px] h-[450px] p-4 rounded-[16px] overflow-y-auto"
		>
			<div className="flex flex-col justify-between items-center h-[90%] gap-2 pt-6">
				<div className="flex justify-center items-center">
					<img
						src={Images.reminderLogo}
						alt="reminder_logo"
						className="h-[9.3rem] w-[14rem]"
					/>
				</div>
				<Typography
					type={TypographyTypes.p}
					className="text-[16px] font-normal leading-[24px] text-justify"
					// eslint-disable-next-line max-len
					title="Send an invitation email to users who haven’t signed in yet. This email will include a download link for the app and login credentials, allowing users to sign in directly to your organization."
					fontLeading="12/12"
				/>
				<div className="w-full flex flex-col sm:flex-row justify-between gap-4 ">
					<Button
						label="Cancel"
						className="!min-w-[14rem]"
						color="Transparent"
						onClick={() => setOpen(false)}
					/>
					<Button
						label="Continue"
						className="!min-w-[14rem]"
						color="Primary"
						onClick={() => {
							setLoginReminder(true)
						}}
					/>
					{loginReminder && (
						<SendReminderModal
							open={loginReminder}
							setOpen={setLoginReminder}
							closeBefore={setOpen}
							secondCloseBefore={setLoginReminder}
							setMyPeopleDataSelected={setMyPeopleDataSelected}
						/>
					)}
				</div>
			</div>
		</TailwindModal>
	)
}
